module.exports = __webpack_public_path__ + "img/box-plus.3a6036a8.svg";